<template>
  <div class="grid-container" :style="state.style">
    <slot />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, reactive } from 'vue'

export type GridContainerProps = {
  rows: string[]
  cols: string[]
  areas: string[][]
}

export default defineComponent({
  props: {
    rows: {
      type: Array,
      required: true
    },
    cols: {
      type: Array,
      required: true
    },
    areas: {
      type: Array,
      required: true
    }
  },
  setup(props) {
    const state = reactive({
      style: computed(() => ({
        '--grid-rows': props.rows.join(' '),
        '--grid-cols': props.cols.join(' '),
        '--grid-areas': (props.areas as string[][]).map(area => `"${area.join(' ')}"`).join(' ')
      }))
    })
    return { state }
  }
})
</script>

<style lang="postcss" scoped>
.grid-container {
  display: grid;
  width: 100vw;
  height: 100vh;
  grid-template-rows: var(--grid-rows);
  grid-template-columns: var(--grid-cols);
  grid-template-areas: var(--grid-areas);
}
</style>
